<template>
  <div>
    <card class="card-user">
      <template slot="header">
        <h4 class="card-title">{{ $t('inspector_teams.detailsTitle') }}</h4>
      </template>
      <div class="author">
        <div class="block block-one"></div>
        <!--        <div class="block block-two"></div>-->
        <div class="block block-three"></div>
        <div class="block block-four"></div>
      </div>
      <div v-loading="loading">
        <table v-if="details">
          <tr>
            <td><label>{{ $t('generic.id') }}:</label></td>
            <td class="pl-2">{{ details.id}}</td>
          </tr>
          <tr>
            <td><label>{{ $t('inspector_teams.details.name') }}:</label></td>
            <td class="pl-2">{{ details.name}}</td>
          </tr>
          <tr>
            <td><label>{{ $t('generic.created') }}:</label></td>
            <td>{{ details.created_at | time }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('generic.createdBy') }}:</label></td>
            <td>{{ details.created_by }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('generic.updated') }}:</label></td>
            <td>{{ details.updated_at | time }}</td>
          </tr>
          <tr>
            <td><label>{{ $t('generic.updatedBy') }}:</label></td>
            <td>{{ details.modified_by }}</td>
          </tr>
        </table>
        <div class="button-container mt-3"
             v-if="details && $auth.can({inspector_team: 'delete'}, 'permissions')">
          <div class="row">
            <div class="col-6" v-if="$auth.can({inspector_team: 'delete'}, 'permissions')">
              <el-tooltip :content="$t('inspector_teams.delete.deleteBtnTooltip')"
                          effect="light"
                          :open-delay="300"
                          placement="bottom">
                <base-button block type="danger" @click.native="handleDelete()">
                  <i class="tim-icons icon-simple-remove pr-2"/> {{ $t('inspector_teams.delete.deleteBtnLabel') }}
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
  import {mapActions, mapState} from "vuex";
  import swal from "sweetalert2";

  export default {
    name: "InspectorTeamDetails",
    components: {
    },
    computed: {
      ...mapState({
        loading: state => state.inspector_teams.loading,
        error: state => state.inspector_teams.error,
        details: state => state.inspector_teams.single,
      }),
    },
    methods: {
      ...mapActions(['GetInspectorTeam', 'JoinInspectorTeam', 'DeleteInspectorTeam', 'LoadInspectorTeamMembers']),
      handleDelete(index, row) {
        swal({
          title: this.$t('inspector_teams.delete.text'),
          text: `'${this.details.name}'`,
          confirmButtonText: this.$t('inspector_teams.delete.actionBtnLabel'),
          cancelButtonText: this.$t('inspector_teams.delete.cancelBtnLabel'),
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          cancelButtonClass: 'btn btn-secondary',
          type: 'question',
          showCancelButton: true
        }).then(result => {
          if (result.value) {
            const details = this.details
            this.DeleteInspectorTeam(this.details.id).then(() => {
              if (this.error == null) {
                if (this.$auth.user().inspector_team_id == this.details.id) {
                  // Refresh token and user data after inspector-team deletion.
                  this.$auth.refresh();
                  this.$auth.fetch();
                }
                this.$notify({
                  type: 'success',
                  message: this.$t('inspector_teams.delete.deletedNotification', {
                    name: this.details.name
                  }),
                  icon: 'tim-icons icon-alert-circle-exc'
                })
                this.$router.push({name: 'inspector_teams'})
              }

            })
          }
        });
      },
    },
    mounted() {
      this.GetInspectorTeam(this.$route.params.id)
    }
  };
</script>
